import { Table } from "react-bootstrap";
import { useHojasTecnicasContext } from "../contexts/HojasTecnicasContext";

const HojasTecnicas = () => {
	const { hojasTecnicas } = useHojasTecnicasContext();

	return (
		<Table striped bordered hover responsive size='sm'>
			<thead>
				<tr>
					<th>PRODUCTO</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				{hojasTecnicas.map((fds, i) => {
					return (
						<tr key={`${i}`} className='fila'>
							<td>{fds.descripcion}</td>
							<td>
								<a
									href={`${process.env.PUBLIC_URL}/hojas/${fds.archivo}`}
									className='btn btn-primary btn-sm btn-download'
									rel='noreferrer'
									target='_blank'
									download
								>
									DESCARGAR DOCUMENTO
								</a>
							</td>
						</tr>
					);
				})}
			</tbody>
		</Table>
	);
};

export default HojasTecnicas;
